<template></template>

<script>
import Constants from "../../js/constants";
import db from "../../js/db";
import mixins from "../../js/mixins";

export default {
  name: "swal-admin-escluso",
  components: {},
  mixins: [mixins],
  mounted() {
    db.on("swalAdminEscluso", this.show);
  },
  destroyed() {
    db.off("swalAdminEscluso", this.show);
  },
  computed: {},
  methods: {
    show(autoescluso = true) {
      const ruolo_da_chiamare = this.asta_settings.ruolo_da_chiamare;
      const testo =
        ruolo_da_chiamare == Constants.RUOLO_DA_CHIAMARE.QUALUNQUE
          ? "la rosa"
          : "i " + Constants.RUOLI_NEW[ruolo_da_chiamare].plurale;
      Swal.fire({
        icon: "warning",
        title: "Attenzione",
        html:
          (autoescluso
            ? "Asta Live ti ha escluso dall'asta in quanto <b>hai completato " +
              testo +
              "</b>."
            : "Ti sei auto escluso dall'asta.") +
          "<br><br> Ricordati che, essendo l'amministratore d'asta, <span style='color:red;'>è necessario che tu rimanga comunque online</span> per consentire agli altri partecipanti di proseguire l'asta." +
          "<br> Se l'amministratore d'asta non è online, Asta Live si bloccherà.",
        confirmButtonText: "Ok, ho capito",
      });
    },
  },
};
</script>
<style></style>
